
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// More thorough service worker unregistration
if ('serviceWorker' in navigator) {
  // Unregister all service workers
  navigator.serviceWorker.getRegistrations().then(registrations => {
    if (registrations.length > 0) {
      console.log(`Unregistering ${registrations.length} service worker(s)...`);
      
      // Unregister each service worker
      const unregisterPromises = registrations.map(registration => {
        console.log('Unregistering service worker:', registration.scope);
        return registration.unregister();
      });
      
      // Wait for all unregistrations to complete
      Promise.all(unregisterPromises).then(() => {
        console.log('All service workers successfully unregistered');
        
        // Clear all caches
        caches.keys().then(cacheNames => {
          if (cacheNames.length > 0) {
            console.log(`Clearing ${cacheNames.length} cache(s)...`);
            
            const clearPromises = cacheNames.map(cacheName => {
              console.log('Deleting cache:', cacheName);
              return caches.delete(cacheName);
            });
            
            // Wait for all cache deletions to complete
            return Promise.all(clearPromises);
          }
        }).then(() => {
          console.log('All caches successfully cleared');
          console.log('Application should now be serving fresh content');
        });
      });
    } else {
      console.log('No service workers found to unregister');
    }
  }).catch(error => {
    console.error('Error during service worker unregistration:', error);
  });
}

createRoot(document.getElementById("root")!).render(<App />);
